module.exports = __webpack_public_path__ + "static/media/IMG_1465.148b6a8f.JPG";